import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../shared/api/supabase';
import { listOwnStaffRoles } from './api';

export const staffKeys = { own: (userId: string) => ['staff', 'own-roles', userId] as const };

export function useOwnStaffRoles(userId: string | undefined) {
  return useQuery({
    queryKey: staffKeys.own(userId ?? ''),
    queryFn: () => listOwnStaffRoles(supabase, userId ?? ''),
    enabled: Boolean(userId),
    staleTime: 60_000,
  });
}
